/**
 * BusinessEquipo — el corazon visible del maker-checker: quien PREPARA y quien
 * APRUEBA. El dueno agrega operadores (RRHH/contabilidad) por email; los
 * operadores preparan nomina y pagos pero NUNCA aprueban (eso es solo el dueno,
 * con su codigo SMS).
 * Visual: .equipo-ola + tokens --fx-* (glass Ola A). Solo chrome.
 */
import { useEffect, useState } from 'react';
import { useSnapshot } from 'valtio';
import { state } from '../../store/global';
import { myBusinesses, addOperator } from '../../lib/business';

export default function BusinessEquipo() {
  const snap = useSnapshot(state);
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    myBusinesses().then((l) => setBusiness(l[0] || null)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const esDueno = business && String(business.ownerUserId) === String(snap.user?.id);

  const onAdd = async () => {
    setBusy(true); setErr(null); setMsg(null);
    try {
      const updated = await addOperator(business._id, email.trim().toLowerCase());
      setBusiness(updated);
      setMsg(`Listo: ${email.trim()} ya puede preparar nomina y pagos (nunca aprobar).`);
      setEmail('');
    } catch (e) {
      setErr(e?.response?.data?.message || 'No se pudo agregar. Verifica el email.');
    } finally { setBusy(false); }
  };

  if (loading) {
    return <div className="equipo-ola"><div className="equipo-ola__loading">Cargando...</div></div>;
  }

  if (!business) {
    return (
      <div className="equipo-ola">
        <header className="equipo-ola__head">
          <p className="equipo-ola__eyebrow">Más · Equipo</p>
          <h1 className="equipo-ola__title">Equipo</h1>
        </header>
        <div className="equipo-ola__panel">
          <p className="equipo-ola__hint">
            Primero vincula tu empresa (en Pagos y nomina). Despues aqui agregas a tu equipo.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="equipo-ola">
      <header className="equipo-ola__head">
        <p className="equipo-ola__eyebrow">Más · Equipo</p>
        <h1 className="equipo-ola__title">Equipo de {business.name}</h1>
        <p className="equipo-ola__sub">Tu equipo prepara; solo tu apruebas con tu codigo. Nadie mueve dinero sin ti.</p>
      </header>

      {err && <div className="equipo-ola__alert equipo-ola__alert--bad">{err}</div>}
      {msg && <div className="equipo-ola__alert equipo-ola__alert--ok">{msg}</div>}

      <div className="equipo-ola__panel equipo-ola__list">
        <div className="equipo-ola__row">
          <div className="equipo-ola__row-body">
            <div className="equipo-ola__row-name">{esDueno ? `${snap.user?.firstName || 'Tu'} (tu)` : 'Dueno de la empresa'}</div>
            <div className="equipo-ola__row-meta">Aprueba cada pago con su codigo SMS · unico con poder de mover dinero</div>
          </div>
          <span className="equipo-ola__badge equipo-ola__badge--owner">Dueno</span>
        </div>
        {(business.operators || []).length === 0 ? (
          <div className="equipo-ola__empty">Aun no hay operadores. Agrega a tu persona de RRHH abajo.</div>
        ) : (
          business.operators.map((o, i) => (
            <div key={i} className="equipo-ola__row">
              <div className="equipo-ola__row-body">
                <div className="equipo-ola__row-name">{o.email}</div>
                <div className="equipo-ola__row-meta">Prepara nomina y pagos · no puede aprobar ni mover un peso</div>
              </div>
              <span className="equipo-ola__badge equipo-ola__badge--op">Operador</span>
            </div>
          ))
        )}
      </div>

      {esDueno ? (
        <div className="equipo-ola__panel">
          <h2 className="equipo-ola__h2">Agregar operador</h2>
          <p className="equipo-ola__hint mb">
            La persona debe tener cuenta FlowexPay (con ese email). Podra subir la nomina y capturar pagos — la aprobacion siempre sera tuya.
          </p>
          <div className="equipo-ola__form">
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && email.includes('@') && onAdd()}
              placeholder="email@delaempresa.com"
              className="equipo-ola__input"
              aria-label="Email del operador"
            />
            <button
              type="button"
              disabled={busy || !email.includes('@')}
              onClick={onAdd}
              className="equipo-ola__btn equipo-ola__btn--primary"
            >
              Agregar
            </button>
          </div>
        </div>
      ) : (
        <div className="equipo-ola__panel equipo-ola__panel--muted">
          <p className="equipo-ola__hint">Solo el dueno de la empresa puede modificar el equipo.</p>
        </div>
      )}
    </div>
  );
}
